export function Footer() {
  const socialLinks = [
    { icon: 'ri-instagram-line', href: '#', label: 'Instagram' },
    { icon: 'ri-twitter-x-line', href: '#', label: 'X (Twitter)' },
    { icon: 'ri-tiktok-line', href: '#', label: 'TikTok' },
  ];

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Events', href: '#news' },
    { name: 'News', href: '#event' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black border-t border-gray-800">
      <div className="container mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4 md:mb-6">
              <img
                src="https://static.readdy.ai/image/958f03ddcb24e17d7d702f4881f49ed8/6cf51e1c0e63b40b6f6c681c6887a621.jpeg"
                alt="U FIRST"
                className="w-10 h-10 md:w-12 md:h-12 rounded-lg object-cover"
              />
              <span className="text-white font-bold text-2xl md:text-3xl">U FIRST</span>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4 md:mb-6 text-sm md:text-base">
              アーティストとファンを繋ぐ新しい体験を創造する<br className="hidden md:block" />
              エンターテインメントプラットフォーム
            </p>
            <div className="flex gap-4">
              {socialLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-gray-800 border border-gray-700 text-gray-400 hover:text-pink-400 hover:border-pink-500/50 transition-all cursor-pointer"
                  aria-label={link.label}
                >
                  <i className={`${link.icon} text-lg md:text-xl`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg md:text-xl mb-4 md:mb-6">Quick Links</h3>
            <ul className="space-y-2 md:space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-pink-400 transition-colors text-sm md:text-base cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg md:text-xl mb-4 md:mb-6">Contact</h3>
            <div className="space-y-3 md:space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-pink-400 mt-1 flex-shrink-0"></i>
                <a href="mailto:ufirst2025@gmail.com" className="text-gray-400 hover:text-pink-400 transition-colors text-sm md:text-base cursor-pointer">ufirst2025@gmail.com</a>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-pink-400 mt-1 flex-shrink-0"></i>
                <a href="tel:08043560612" className="text-gray-400 hover:text-pink-400 transition-colors text-sm md:text-base cursor-pointer">080-4356-0612</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 md:mt-12 pt-6 md:pt-8">
          <div className="flex justify-center items-center">
            <p className="text-gray-500 text-xs md:text-sm text-center">
              © 2025 U FIRST. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
